<template>
<div style="position: relative">
  <slot></slot>
 <div class="popover-com" v-if="Sensitive.length > 0">
    <h3>文内涉及敏感词</h3>
    <p>请删减或修改敏感词：</p>
    <div class="text-box">
      <template v-for="(item, index) in Sensitive">
        <span v-if="index !== 0" :key="item + index"> / </span><span class="error-text" :key="index">{{ item }}</span>
      </template>
    </div>
    <div class="del-btn" @click="clear"><a-icon type="close" /></div>
    <div class="popper_arrow"></div>
  </div>
</div>
 
</template>

<script>

export default {
  props: {
    text: {
      default: () => [],
    },
  },
  watch: {
    text: function (val) {
      this.throttle(this.getSensitiveWordFn, 500)(val)
    },
  },
  mounted() {},
  data() {
    return {
      Sensitive: [],
      timeout: null,
    }
  },
  methods: {
    // 节流函数
    throttle(func, delay) {
      let then = this
      return function () {
        const context = this
        const args = arguments
        if (then.timeout) {
          clearTimeout(then.timeout)
        }
        then.timeout = setTimeout(function () {
          func.apply(context, args)
          then.timeout = null
        }, delay)
      }
    },
    getSensitiveWordFn(text) {
      this.$getSensitiveWordFn(text).then(res=>{
        if(res.code===1){
          this.Sensitive=res.data
        }
      })
    },
    clear() {
      this.Sensitive = []
    },
  },
}
</script>

<style>
p {
  padding: 0;
  margin: 0;
}
.popover-com {
  position: absolute;
  top: calc(100% + 6px);
  z-index: 888;
  left: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-width: 320px;
  min-width: 200px;
  
  /* overflow: auto; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.text-box{
  max-height: 300px;
  overflow: auto;
}
/* 三角形指示器样式 */
.popper_arrow,
.popper_arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popper_arrow {
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: #ccc;
}
.popper_arrow:after {
  top: 1px;
  border-width: 6px;
  content: '';
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: #fff;
}
.error-text {
  color: #f53f3f;
  line-height: 20px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.del-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
</style>